export const isString = (maybeString: any): boolean => typeof maybeString === "string";
